import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const submitContactForm = createAsyncThunk(
  "contact/submitForm",
  async (data) => {
    const response = await api.post("/contact", data);
    return response.data;
  }
);